export const STORE_KEY_PREFIX = 'interview_tool_';
export const STORE_AUTH_TOKEN = 'authorize_token';
export const STORE_REFRESH_TOKEN = 'refresh_token';
export const ACCESS_TOKEN_EXPIRATION = 1000 * 60 * 30;
